module.exports = __webpack_public_path__ + "static/media/tournament-thumb-one-pocket.ffb5b099.png";